module.exports = __webpack_public_path__ + "static/img/tit08.687eb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tit08.png
// module id = R0je
// module chunks = 0